module.exports = __webpack_public_path__ + "static/img/wpp3_2.51580b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp3_2.png
// module id = cU9N
// module chunks = 2